import { useState } from "react";
import DatePicker from "react-datepicker";

const DateInput = ({
  value,
  onChangeDate,
  inputClassName,
  required,
  minDate,
  maxDate,
  imageStyle,
  disabled,
}) => {
  const [selectedDate, setSelectedDate] = useState(value);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onChangeDate(date);
  };

  return (

    <>
      <div style={{ position: "relative" }}>
        <img src={"/images/calnder.png"} alt="" className="zIndex-11" style={imageStyle || { width: "22px", height: "22px", position: "absolute", borderRadius: "0px", marginBlock: "17px", left: "15px", top: "0", zIndex: "111" }} />
        <DatePicker
          selected={selectedDate}
          onChange={(date) => handleDateChange(date)}
          dateFormat="MM-dd-yyyy"
          disabled={disabled}
          minDate={minDate || new Date("1900/01/01")}
          maxDate={maxDate || new Date("2100/01/01")}
          className={`description_inputf mb-0 pl-2 ${inputClassName}`}
          showMonthDropdown
          required={required}
          showYearDropdown
          yearDropdownItemNumber={300}
          scrollableYearDropdown
          style={{
            width: "100%",
          }}
        />
      </div>
      </>

  );
};
export default DateInput;
